export default "__VITE_ASSET__B6KcWzA6__"